


























import commerces from '@/components/commerce/Partners/tables/commerces.vue';
import Vue from 'vue';

export default Vue.extend({
  name: 'CommerceParners',
  components: {
    commerces,
  },
});
